import { action } from 'typesafe-actions';

import { Guest } from 'services/userGuestService';

export const SET_GUEST = 'SET_GUEST';

export const RESET = 'RESET_GUEST';

export interface SetGuest {
  type: typeof SET_GUEST;
  guest: Guest;
}
export interface Reset {
  type: typeof RESET;
}

export type TravelArrangerGuestActions = SetGuest | Reset;

export const doSetGuest = (guest: Guest) => action(SET_GUEST, guest);

export const doReset = () => action(RESET);
